var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnsubscribe = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  stroke: "currentcolor",
  d: "M3 12.75h3.5v.5H3c-.69 0-1.25-.56-1.25-1.25V4c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v3.5h-.5V5.347l-.658.22L8 7.263 2.908 5.566l-.658-.22V12c0 .414.336.75.75.75Zm4.842-6.066L8 6.737l.158-.053 5.25-1.75.342-.114V4a.75.75 0 0 0-.75-.75H3a.75.75 0 0 0-.75.75V4.82l.342.114 5.25 1.75ZM10.25 11.5a.25.25 0 0 1 .25-.25h3a.25.25 0 1 1 0 .5h-3a.25.25 0 0 1-.25-.25Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnsubscribe);
export default ForwardRef;